import { useTranslation } from 'react-i18next';
import { CelebrationCheck } from '@bliks-io/ui';
import { useCompletedCount } from '@/stores/celebration-store';

export function AllDoneBanner() {
  const { t } = useTranslation();
  const completedCount = useCompletedCount();

  if (completedCount === 0) return null;

  return (
    <div className="flex items-center gap-4 rounded-xl border border-positive-line bg-positive-surface p-4">
      <CelebrationCheck size="md" />
      <div className="min-w-0 flex-1">
        <p className="text-base font-semibold">{t('celebration.banner.title')}</p>
        <p className="text-sm text-muted-foreground">
          {t('celebration.banner.description', { count: completedCount })}
        </p>
      </div>
      <div className="flex shrink-0 flex-col items-end gap-0.5 text-sm">
        <span className="font-medium text-positive-strong">
          {t('celebration.banner.doneCount', { count: completedCount })}
        </span>
        <span className="text-muted-foreground">
          {t('celebration.banner.openCount', { count: 0 })}
        </span>
      </div>
    </div>
  );
}
